import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import login from './components/Login.vue'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

Vue.use(Vuex);
Vue.use(VueToast);

Vue.component('login', login)
Vue.config.productionTip = false

const store = new Vuex.Store({
  state : {
    count : 0,
    user : {
      email : localStorage.getItem('email') || "",
      password : localStorage.getItem('password') || "",
      loggedIn : localStorage.getItem('loggedIn') || false,
      role : localStorage.getItem('role') || "user"
    }
  },
  mutations : {
      setRole(state, role)
      {
        console.log("setting role " + role);
        state.user.role = role;
        localStorage.setItem('role', role);

      },
      increment(state)
      {
        state.count++
      },
      setEmail(state, email) {
        console.log("setting email " + email);
        state.user.email = email;
        localStorage.setItem('email', email);
      },
      setPassword(state, password) {
        console.log(password);
        state.user.password = password;
        localStorage.setItem('password', password);
      },
      userLoggedIn(state)
      {
        state.user.loggedIn = true;
        localStorage.setItem('loggedIn', true);
      },
      userLoggedOut(state)
      {
        state.user.loggedIn = false;
        localStorage.setItem('loggedIn', false);
      },
  },
  actions : {
    increment(context)
    {
      context.commit('increment');
    },
    logout({commit})
    {
      console.log("logging out");
      commit('setPassword', null);
      commit('setEmail', null);
      commit('userLoggedOut');

      
    },
    updateEmail({commit}, email)
    {
      commit('setEmail', email);
      localStorage.setItem('email', email);
      //commit('updateEmail', payload.email);
    }
  },
  getters : {
    email : state => {
      return localStorage.getItem('email') || state.user.email
    },
    user : state => {
      if(typeof state.user.loggedIn == "string")
      {
        if(state.user.loggedIn == "true")
          state.user.loggedIn = true;
          else
          state.user.loggedIn = false;
      }
      console.log(typeof state.user.loggedIn);
      return state.user
    },
    password : state => {
      return state.user.password
    }
  }
});


new Vue({
  render: h => h(App),
  store,
  router,
  toast : VueToast
}).$mount('#app')
